import { takeLatest, put } from 'redux-saga/effects';
import { GET_APP_DATA } from 'constants/action-types';
import { getAuctionsPushNotificationToken } from '../store/site-actions';

function* fetchAppData() {
  yield put(getAuctionsPushNotificationToken());
}

export default function* appSaga() {
  yield takeLatest(GET_APP_DATA, fetchAppData);
}
